import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbParagraph from '../../../shared/components/VerbParagraph';

const HomeRowWrapper = ({ labelTextId = ' ', labelDefaultMessage = '', children, className, subtext }) => (
    <div className={`container home-row-wrapper ${className}`}>
        <div className={'row no-horizontal-margin heading-container'}>
            <VerbHeading
                className={'col-12 home-row-wrapper-heading'}
                hNumber={5}
                messageId={labelTextId}
                defaultMessage={labelDefaultMessage}
            />
            {subtext ? (
                <VerbParagraph className={'category-subtext col-12'} formatIntl={false} customMessage={subtext} />
            ) : null}
        </div>
        <div className={cns('row no-horizontal-margin')}>
            <div className={'col-12'} style={{ padding: '0' }}>
                {children}
            </div>
        </div>
    </div>
);

HomeRowWrapper.propTypes = {
    labelDefaultMessage: PropTypes.string,
    labelTextId: PropTypes.string,
    children: PropTypes.any,
    subtext: PropTypes.string,
    className: PropTypes.string
};

export default HomeRowWrapper;
